export default __webpack_public_path__ + "static/media/prod-pc.3aea4587.gif";